<div class="well well-sm col-xs-12" [ngClass]="ttClass">
    <div [hidden]="!heading && !ttAccordion" class="col-xs-12 sp-0">
        <div class="sp-5" style="display: flex; align-items: center">
            <h3 class="tt-card__heading" [style.opacity.0]="!heading">
                <span *ngIf="ttIcon !== null && ttIcon !== undefined" class="fa-fw" [ngClass]="ttIcon"></span>
                {{ heading || " " }}
                <ng-content select="[heading]"></ng-content>
            </h3>
            <button *ngIf="ttAccordion" tabindex="-1" class="tt-card__accordion-button" (click)="toggleAccordion()">
                <span class="fa-fw far" [ngClass]="isAccordionOpen ? 'fa-chevron-down' : 'fa-chevron-up'"></span>
            </button>
        </div>
        <!-- <div class="k-hr col-xs-12 sp-0"></div> -->
    </div>
    <div [ngClass]="ttClass + (ttAccordion ? ' tt-card__content' : '') + (isAccordionClosed ? ' tt-card__content--hidden' : '')" [attr.inert]="isAccordionOpen ? null : 'true'">
        <hr *ngIf="!!heading || ttAccordion" class="col-xs-12 sp-0 tt-card__hr" />
        <!-- <div class="col-xs-12 sp-0"> -->
        <ng-content></ng-content>
        <!-- </div> -->
    </div>
</div>
